import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { isDev } from "./helpers/globals";
import "./translations/i18n";

/**
 * Below code makes sure the React app renders in the following scenarios:
 * 1: When running in dev
 * 2: When the active variant is out of stock (but not low on stock). They both have the same dataLayer value, but different button classes
 * 3: When toggled to a variant that's out of stock
 */
function createReactApp() {
  const buttonOutOfStock =
    !!document.querySelector(
      ".bose-cta:not(.bose-cta--hide) .bose-buttonLink__buyButton.-disabled"
    ) ||
    !!document.querySelector(
      ".bose-cta:not(.bose-cta--hide) .js-cta__resellerDirectButton.-disabled"
    );
  const isOutOfStock = isDev ? true : buttonOutOfStock;
  const App = React.lazy(() => import("./App"));

  function initPage(): [Element | null, "old" | "new"] {
    if (isDev) {
      return [document.getElementById("root"), "new"];
    }

    const newProductPage = document.querySelector(
      ".bose-shippingMethod__stockDetails.js-stockDetails .bose-productATP:not(.bose-productATP--hide)"
    );
    const oldProductPage = document.querySelector(".productATP");
    const oldProductPageCta = document.querySelector<HTMLElement>(
      ".productCallToActions"
    );

    if (newProductPage) {
      return [newProductPage, "new"];
    }

    if (oldProductPage && oldProductPageCta && isOutOfStock) {
      oldProductPageCta.style.display = "none";
    }

    return [oldProductPage, "old"];
  }

  const [selector, pdpVersion] = initPage();

  if (isOutOfStock) {
    const queryClient = new QueryClient();

    ReactDOM.render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={null}>
            <App pdpVersion={pdpVersion} />
          </Suspense>
        </QueryClientProvider>
      </React.StrictMode>,
      selector
    );
  }
}

(() => {
  createReactApp();
  window.addEventListener("hashchange", createReactApp);
})();
